export default __webpack_public_path__ + "static/media/user.a2423cc3.svg";